import {TrackingPageContext} from '../../../types';

export function pageKey(page: TrackingPageContext): PageKey {
  return `${page.type}_${page.id}` as PageKey;
}

export type PageKey = string & {
  readonly ____tagPageKey: unique symbol;
};
